export default {
  methods: {
    statusStyleClass(statusString) {

      switch (statusString) {

        case 'pakkumises':
          return 'success-light'

        case 'vip':
        case 'lepinguline':
        case 'paid':
          return 'success'

        case 'eksport':
        case '0% km, väliskilent':
          return 'info'

        case 'lepinguline ettemaks':
        case 'ettemaks':
          return 'warning'

        case 'mitte teenindada':
        case 'pankrotis':
        case 'tegevus lõpetatud':
          return 'danger'

        default:
          return 'light'

      }
    }
  }
}
